<template>
	<LayoutList>
		<template slot="header">
			<h1>Opportunities</h1>
			<a :href="downloadURL" class="btn btn-download">Download All</a>
			<router-link to="/opportunities/create" class="btn btn--primary" v-if="can('createOpportunities')">
				Create
			</router-link>
		</template>

		<template slot="filters">
			<FormControlSector
                name="sectors"
                v-model="sectors"
                :multiple="true"
                :include-ancestors="false"
            />
			<FormControlDealType
                name="dealType"
                v-model="filters.deal_type"
                :allow-empty="true"
            />
			<FormControlMember
                name="member"
                v-model="filters.member"
                :allow-empty="true"
                placeholder="Select..."
                label="Member company"
            />
			<FormControlDatepicker
                name="fromDate"
                v-model="filters.fromDate"
                label="From date"
            />
			<FormControlDatepicker
                name="toDate"
                v-model="filters.toDate"
                label="To date"
            />
		</template>

		<div class="form__group search" slot="search">
			<label for="local-search" class="form__label">Search Opportunities</label>
			<input
                id="local-search"
                class="form__control search"
                type="search"
                placeholder="Filter by title"
                v-model="filters.query"
            />
		</div>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="all" title="All Opportunities">
				<ListOpportunities
                    ref="all"
                    :load-on-start="false"
                    :filters="filteredFilters"
                />
			</v-tab>
			<v-tab id="mine" title="My Opportunities">
				<ListOpportunities
                    ref="mine"
                    :load-on-start="false"
                    :filters="filteredFilters"
                    :mine-only="true"
                />
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>

<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '../Layout/LayoutList';
	import ListOpportunities from '../List/ListOpportunities';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlDealType from '../Form/Control/FormControlDealType';
	import FormControlMember from '../Form/Control/FormControlMember';
	import FormControlDatepicker from '../Form/Control/FormControlDatepicker';
	import TabbedPage from '../TabbedPage';
	import FiltersFromUrl from '../FiltersFromUrl';
	import qs from 'qs';

	export default {
		name: 'OpportunityList',
		mixins: [TabbedPage, FiltersFromUrl],
		components: {
			FormControlMember,
			FormControlDealType,
			FormControlSector,
			FormControlDatepicker,
			ListOpportunities,
			LayoutList,
		},
		computed: {
			...mapGetters([
				'can',
				'opportunities'
			]),
			downloadURL() {
				return '/opportunities/download?' + qs.stringify(this.filters);
			},
            filteredFilters() {
                return {
                    sectors: this.sectors,
                    deal_type: this.filters.deal_type,
                    member: this.filters.member,
                    query: this.filters.query,
                    fromDate: this.filters.fromDate,
                    toDate: this.filters.toDate
                }
            },
            sectors: {
                get() {
                    return this.filters.sectors.filter(function (el) {
                        return el !== 0;
                    });
                },
                set(value) {
                    this.filters.sectors = value;
                }
            }
		},
		data() {
			return {
				filters: {
					type: null,
					sectors: [],
					deal_type: null,
					member: null,
					query: null,
					fromDate: null,
					toDate: null
				},
				defaultTab: 'all',
				tabRoute: 'opportunities',
			}
		},
		watch: {
			filters: {
				deep: true,
				handler() {
					this.$store.commit('modifyOpportunity', {
						query: this.filters.query,
                        sectors: this.sectors,
						deal_type: this.filters.deal_type,
						member_company: this.filters.member,
						from_date: this.filters.fromDate,
						to_date: this.filters.toDate
					});

                    this.$refs.all.resetPagination();
                    this.$refs.mine.resetPagination();
				}
			}
		},
		methods: {
			load() {
				// this.filters.query = this.opportunities.query;
				// this.filters.sectors = this.opportunities.sectors;
				// this.filters.deal_type = this.opportunities.deal_type;
				// this.filters.member = this.opportunities.member_company;
				// this.filters.fromDate = this.opportunities.from_date;
				// this.filters.toDate = this.opportunities.to_date;
			},
		},
		created() {
			this.load();
		}
	}
</script>
